import { Popover as NextUIPopover } from '@nextui-org/react';
import styled from 'styled-components';

import { Chevron2Icon, CloseIcon } from '../../assets';
import { ThemeProp } from '../../theme/Themes';
import Button from '../Button';
import IconButton from '../Button/IconButton';
import SecondaryButton from '../Button/SecondaryButton';

interface StyledButtonProps {
  $isOpen?: boolean;
  $hasSelectedOptions?: boolean;
}

export const StyledButton = styled(Button)<StyledButtonProps>`
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  border: 1px solid
    ${(props: StyledButtonProps & ThemeProp) =>
      props.$isOpen || props.$hasSelectedOptions ? props.theme.colors.main.c600 : props.theme.colors.neutrals.c200};
  border-radius: 0.5rem;
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
  padding: 0.438rem 0.625rem;
  flex-shrink: 0;
  min-width: unset;

  > span {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: fit-content;
    gap: 0.25rem;
  }

  svg {
    path {
      stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c500};
    }
  }

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.neutrals.c050};
  }

  &:active {
    background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  }

  &:focus {
    background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  }
`;

export const StyledChevron = styled(Chevron2Icon)<{ $isOpen: boolean }>`
  ${(props) => props.$isOpen && 'transform: rotate(180deg);'};
  margin-left: 0.125rem;
`;

export const StyledCloseIcon = styled(CloseIcon)`
  margin-left: -0.25rem;
  margin-right: -0.375rem;
`;

export const CountComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.875rem;
  height: 0.875rem;
  padding-left: 0;
  font-size: 0.563rem; // NOTE: Design Specs
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  color: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  background: ${(props: ThemeProp) => props.theme.colors.main.c600};
  border-radius: 50%;
`;

export const StyledIconButton = styled(IconButton)`
  background: transparent;
  width: fit-content;
`;

export const ContentContainer = styled(NextUIPopover.Content)`
  display: flex;
  flex-direction: column;
  min-width: 14rem;
  padding: 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  border-radius: 0.5rem;
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.tooltips};
`;

export const ItemsContainer = styled.div`
  display: flex;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  padding: 0.75rem 0.5rem 0.5rem 0.5rem;
  gap: 0.5rem;
`;

export const StyledApplyButton = styled(Button)`
  flex: 1;
  height: 1.75rem;
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  flex: 1;
  height: 1.75rem;
`;
